/**
 * Alert Banner
 */
import { Component, registerComponent } from 'js/component.js';
import { isEditModeFooter } from 'js/helpers.js';
const componentName = 'alert-banner';
const LS = window.localStorage;

class AlertBanner extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        body: document.body,
        container: this.element.querySelector(`.${componentName}__container`),
        closeButton: this.element.querySelector(`.${componentName}__close`)
    };

    // Util & State
    debug = false;
    alertEvent = new CustomEvent('rockwell-alert', null);
    dataBaseUrl = this.elements.container ? this.elements.container.dataset.path : null;
    state = {
        lastModified: 0,
        disabled: false
    };

    /**
     * Disable Alert Banner
     */
    disableAlert = () => {
        this.elements.body.classList.remove('alert-active');
        this.elements.body.classList.add('alert-disabled');

        window.dispatchEvent(this.alertEvent);
    };

    /**
     * Enable Alert Banner
     */
    enableAlert = () => {
        this.elements.body.classList.remove('alert-disabled');
        this.elements.body.classList.add('alert-active');

        window.dispatchEvent(this.alertEvent);
    };

    /**
     * Check Local Storage
     */
    checkLocalStorage = () => {
        const LSData = JSON.parse(LS.getItem('rockwell-alert'));

        if(LSData) {
            if(LSData.disabled && LSData.lastModified !== this.state.lastModified) {
                this.state.disabled = false;
                this.enableAlert();
                window.dispatchEvent(this.alertEvent);
            }

            if(LSData.disabled && LSData.lastModified === this.state.lastModified) {
                this.state.disabled = true;
            }

            if(!LSData.disabled) {
                this.state.disabled = false;
                this.enableAlert();
            }
        } else {
            this.enableAlert();
        }

        this.updateLocalStorage();
    };

    /**
     * Update Local Storage
     */
    updateLocalStorage = () => {
        LS.setItem('rockwell-alert', JSON.stringify(this.state));
    };

    /**
     * Close Alert Banner
     */
    closeAlert = () => {
        this.disableAlert();
        this.state.disabled = true;
        this.updateLocalStorage();
        window.dispatchEvent(new CustomEvent('rockwell-alert-showhide', null));
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        this.elements.closeButton.addEventListener('click', this.closeAlert);
    };

    /**
     * Initialize Component
     */
    init() {
        if(isEditModeFooter()) this.element.setAttribute('aria-hidden', 'false');
        if(!this.elements.container || isEditModeFooter()) return;
        if(this.debug) {
            this.state.disabled = false;
            this.updateLocalStorage();
        }

        const self = this;

        fetch(this.dataBaseUrl, {
            headers: {
                'Cache-Control': 'max-age=3600'
            }
        }).then((response) => {
            if(!response.ok) {
                throw new Error('Response failed');
            }
            return response.json();
        }).then((response) => {
            self.state.lastModified = response.data.lastModified;
            self.disableAlert();
            self.checkLocalStorage();
            self.addEventListeners();
        }).catch((error) => {
            console.log(error);//eslint-disable-line
        });
    }
}

registerComponent(`.${componentName}`, AlertBanner);
